import Swiper from '../js/vendor/swiper/swiper.min';
import '../styles/page-omoss.scss';

let advisorSwiper = new Swiper('.advisor-container--default', {
	updateOnWindowResize: true,
	slidesPerView: 3,
	spaceBetween:0,
	grabCursor: true,
	loop:true,
	loopedSlides:10,
	centeredSlides:true,
	navigation: {
		nextEl: '.swiper-button-next-advisor',
		prevEl: '.swiper-button-prev-advisor',
	},
	breakpoints: {
		1200: {
			slidesPerView: 3,
			spaceBetween:0,
			grabCursor: true,
			loop:true,
			loopedSlides:10,
			centeredSlides:true,
		},
		719: {
			slidesPerView: 1,
			spaceBetween:0,
			grabCursor: true,
			loop:true,
			loopedSlides:null,
			centeredSlides:true,
			initialSlide:7,
		}
	}
});

let advisorSwiperExp = new Swiper('.advisor-container--exp', {
	updateOnWindowResize: true,
	slidesPerView: 3,
	spaceBetween:0,
	grabCursor: true,
	centeredSlides:false,
	navigation: {
		nextEl: '.swiper-button-next-advisor',
		prevEl: '.swiper-button-prev-advisor',
	},
	breakpoints: {
		1200: {
			slidesPerView: 3,
			spaceBetween:0,
			grabCursor: true,
			centeredSlides:false,
		},
		719: {
			slidesPerView: 1,
			spaceBetween:0,
			grabCursor: true,
			centeredSlides:true,
		}
	}
});

let cardSwiper = new Swiper('.why-block__container', {
	slidesPerView: 3,
	spaceBetween:30,
	grabCursor: true,
	keyboard: false,
	allowTouchMove: false,
	mousewheel: false,
	simulateTouch:false,
	breakpoints: {
		1200: {
			slidesPerView: 3,
			spaceBetween: 30,
			keyboard: false,
			allowTouchMove: false,
			mousewheel: false,
			simulateTouch:false,
		},
		1024: {
			slidesPerView: 2.4,
			spaceBetween: 15,
			slidesOffsetBefore:25,
			slidesOffsetAfter:25,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
		},
		719: {
			slidesPerView: 1.3,
			spaceBetween: 15,
			slidesOffsetBefore:25,
			slidesOffsetAfter:25,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
		}
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: 'true'
	},
});

let timeEl = document.getElementById("timeLineRow");
let timeProgressBar = document.getElementById("timeProgressBar");
if(timeProgressBar){ timeProgressBar.style.width = "88px"; }

window.addEventListener("load", customScrollLoadFunction);

function customScrollLoadFunction(e){
	customScrollResizeFunction();

	window.addEventListener("resize", customScrollResizeFunction);
}

function customScrollResizeFunction (e){
	if(timeProgressBar){
		let timeElWidth = document.getElementById('timeLineProgress').clientWidth;

	timeEl.addEventListener('scroll', event => {
		let scrolled = (timeEl.scrollLeft / (timeEl.scrollWidth - timeEl.clientWidth) ) * 100;
		let scrollCustom = (timeElWidth - timeProgressBar.clientWidth)/100 * scrolled
		timeProgressBar.style.transform = "translate3d(" + scrollCustom + "px, 0px, 0px)"
	});
	}
}

if(document.body.classList.contains('city-exp-chal-1')) {
  if (window.innerWidth < 576) {
    let accItem = document.getElementsByClassName('about-why__column');
    let mobMenuBtn = document.getElementsByClassName("about-why__header");
    let i;
    for (i = 0; i < mobMenuBtn.length; i++) {
      mobMenuBtn[i].addEventListener('click', toggleItemPlus, false);
    }

    function toggleItemPlus() {
      let itemClass = this.parentNode.className;
      for (i = 0; i < accItem.length; i++) {
        accItem[i].className = 'about-why__column collapsed';
      }
      if (itemClass == 'about-why__column collapsed') {
        this.parentNode.className = 'about-why__column active';
      }
    }
  }
}




